import { useCallback } from 'react';

import { useExtendedLogger } from '../../Logger';

import { DateFormatConfig, resolveLocaleFormats } from '../config/formatConfig';
import { LOGGER_NAME } from '../config/constants';
import type { DateConfigOptions } from '../types';

export function useDateTimeConfig() {
  const log = useExtendedLogger(LOGGER_NAME);

  const setConfig = useCallback(
    (patternOptions?: DateConfigOptions) => {
      const { locale, is24HourFormat, overrides } = patternOptions ?? {};
      log(
        'setConfig called — locale: %s, is24HourFormat: %s, overrides: %o',
        locale,
        is24HourFormat,
        overrides
      );
      if (locale) {
        Object.assign(DateFormatConfig, resolveLocaleFormats(locale, is24HourFormat, overrides));
        log('DateFormatConfig updated %o', DateFormatConfig);
      }
    },
    [log]
  );

  return { config: DateFormatConfig, setConfig };
}
